module.exports = {"640381001":"裕民街道","640381100":"小坝镇","640381101":"大坝镇","640381102":"青铜峡镇","640381103":"叶盛镇","640381104":"瞿靖镇","640381105":"峡口镇","640381106":"邵岗镇","640381107":"陈袁滩镇","640381400":"连湖农场","640381401":"树新林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/640381.json
// module id = 2825
// module chunks = 0